import React from "react";
import ModalConfirmarInfoPersonal from "../../../componentesEspeciales/cuenta/modalConfirmarInfo";





function InfoPersonal({ usuario, perfil, ciudades, cambiarCampo, guardarPerfil, }) {
    return (
        <>
            {/* TITULO Y BOTONES INFOR PERSONAL */}
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h2 className="mb-0">Información personal</h2>
                <div className="d-flex gap-2">
                    {/* BOTÓN GUARDAR */}
                    {usuario?.perfilPersonalCompleto ? null : (
                        <button
                            className="btn btn-primary"
                            onClick={() => { guardarPerfil("Personal"); }}
                        >
                            <i className="bi bi-check2-circle me-2"></i>
                            Guardar info personal
                        </button>
                    )}

                    {/* USUARIO VERIFICADO */}
                    {usuario?.verificacionIdentidad?.estado === "aprobado" && (
                        <button className="btn btn-success" onClick={() => {}}>
                            <i className="bi bi-patch-check-fill me-2"></i>
                            Usuario verificado
                        </button>
                    )}

                    {/* INFO PERSONAL CONFIRMADA */}
                    {usuario?.perfilPersonalCompleto && (
                        <button className="btn btn-success" onClick={() => {}}>
                            <i className="bi bi-patch-check-fill me-2"></i>
                            Info personal confirmada
                        </button>
                    )}
                </div>
            </div>

            {/* INPUTS INFORMACIÓN PERSONAL */}
            <div className="row g-3">
                {/* NOMBRE */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            value={perfil.nombre}
                            onChange={(e) => cambiarCampo("nombre", e.target.value)}
                            placeholder="Nombre"
                            readOnly={usuario?.perfilPersonalCompleto === true}
                        />
                        <label>Nombre</label>
                    </div>
                </div>

                {/* APELLIDO */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            value={perfil.apellido}
                            onChange={(e) => cambiarCampo("apellido", e.target.value)}
                            placeholder="Apellido"
                            readOnly={usuario?.perfilPersonalCompleto === true}
                        />
                        <label>Apellido</label>
                    </div>
                </div>

                {/* TIPO IDENTIFICACIÓN */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <select
                            className="form-select"
                            value={perfil.tipoIdentificacion}
                            onChange={(e) => cambiarCampo("tipoIdentificacion", e.target.value)}
                            disabled={usuario?.perfilPersonalCompleto === true}
                        >
                            <option value="Identificación nacional">Identificación nacional</option>
                            <option value="Pasaporte">Pasaporte</option>
                        </select>
                        <label>Tipo de identificación</label>
                    </div>
                </div>

                {/* IDENTIFICACIÓN */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            value={perfil.identificacion}
                            onChange={(e) => cambiarCampo("identificacion", e.target.value)}
                            placeholder="Identificación"
                            readOnly={usuario?.perfilPersonalCompleto === true}
                        />
                        <label>Número de identificación</label>
                    </div>
                </div>

                {/* TELÉFONO */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="tel"
                            className="form-control"
                            value={perfil.telefono}
                            onChange={(e) => cambiarCampo("telefono", e.target.value)}
                            placeholder="Teléfono"
                            readOnly={usuario?.perfilPersonalCompleto === true}
                        />
                        <label>Teléfono</label>
                        <p className="textoBajoInput">Ej: +57 300 123 4567</p>
                    </div>
                </div>

                {/* CIUDAD */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <select
                            className="form-select"
                            value={perfil.ciudad}
                            onChange={(e) => cambiarCampo("ciudad", e.target.value)}
                            disabled={usuario?.perfilPersonalCompleto === true}
                        >
                            <option value="">Seleccione una ciudad</option>
                            {!ciudades
                                ? null
                                : ciudades.map((c, idx) => (
                                      <option key={idx} value={c}>
                                          {c}
                                      </option>
                                  ))}
                        </select>
                        <label>Ciudad</label>
                    </div>
                </div>

                {/* PAIS */}
                <div className="col-12">
                    <div className="form-floating">
                        <input type="text" className="form-control" value={perfil.pais} readOnly placeholder="País" />
                        <label>País</label>
                        <p className="textoBajoInput">Por defecto: Colombia (luego podrás cambiar el país).</p>
                    </div>
                </div>
            </div>

            {/* CONFIRMAR INFORMACIÓN PERSONAL */}
            {usuario?.perfilPersonalCompleto ? null : (
                <ModalConfirmarInfoPersonal cualInfo={"Personal"} datos={perfil} idUsuario={usuario.idUsuario} />
            )}

            <hr className="my-4" />
        </>
    );
}

export default InfoPersonal;